<template>
    <div>
        <Tab name="3"></Tab>
        <div class="page-filter-box">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-input v-model="params.value" class="input-with-select" size="small">
                        <el-select v-model="params.type" slot="prepend" placeholder="请选择">
                            <el-option label="频道ID" :value="1"></el-option>
                            <el-option label="频道名称" :value="2"></el-option>
                        </el-select>
                    </el-input>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.status" placeholder="请选择" size="small">
                        <el-option label="仅看启用的" :value="1"></el-option>
                        <el-option label="仅看禁用的" :value="0"></el-option>
                        <el-option label="不限制状态" :value="-1"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="5" :xl="4" class="page-filter-btns">
                    <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                    <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
                </el-col>
            </el-row>
        </div>
        <div class="page-btns-box">
            <el-button  v-if="$utils.have('/channel/save')"  type="primary" icon="el-icon-plus" @click="add" size="small">创建频道</el-button>
            <el-button  v-if="$utils.have('/channel/sort/list')"  type="primary" icon="el-icon-sort" @click="sort(1)" size="small">发现页精选排序</el-button>
            <el-button  v-if="$utils.have('/channel/sort/list')"  type="primary" icon="el-icon-sort" @click="sort(2)" size="small">特刊排序</el-button>
        </div>
         <div class="page-list-box">
            <el-table
                :data="dataList"
                border
                style="width: 100%"
                v-loading="listLoading"
                size="small"
                stripe
            >
                <el-table-column prop="id" label="ID"></el-table-column>
                <el-table-column prop="name" label="名称" show-overflow-tooltip></el-table-column>
                <el-table-column prop="bindNum" label="绑定视频"></el-table-column>
                <el-table-column prop="status" label="状态">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.status == 1" type="success" size="mini">启用</el-tag>
                        <el-tag v-else type="info" size="mini">禁用</el-tag>
                    </template>
                </el-table-column>
                <el-table-column fixed="right" label="操作" width="80">
                    <template slot-scope="scope">
                        <el-button
                            v-if="$utils.have('/channel/save') && scope.row.id != 1 && (scope.row.id < 34 || scope.row.id > 40)"
                            type="text"
                            size="small"
                            icon="el-icon-edit"
                            @click="edit(scope.row.id)"
                            >编辑</el-button
                        >
                    </template>
                </el-table-column>
            </el-table>
         </div>
         <div v-if="data" class="page-pagination-box">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="getDataList"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="data.totalCount || 0">
            </el-pagination>
        </div>
        <Sort ref="channelSort" @onUpdate="getDataList"></Sort>
    </div>
</template>
<script>
import Tab from '../../components/tab';
import Sort from './components/sort';
const defaultParams = {
    pageNo: 1,
    type:1,
    value:'',
    status: 1
}
export default {
    components:{Tab,Sort},
    data(){
        return {
            data: null,
            dataList: null,
            params:{
                ...defaultParams,
                pageSize: this.$pageSizes[0],
            },
            listLoading: false, 
        }
    },
    mounted(){
        this.getDataList();
    },
    methods:{
        //获取列表
        getDataList() {
            this.listLoading = true;
            this.$request({
                url: "/channel/list",
                method: "POST",
                data: {
                    ...this.params,
                },
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.data = result;
                        this.dataList = result.result || [];
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.listLoading = false;
                });
        },
        //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.getDataList();
        },
        //重置搜索
        reset() {
            this.params = {
                ...defaultParams,
                pageSize: this.params.pageSize,
            };
            this.getDataList();
        },
        sort(type){
            this.$refs.channelSort.show(type);
        },
        add(){
            this.$router.push({name:'channelAdd'})
        },
        edit(id){
            this.$router.push({
                name:'channelEdit',
                params:{id: id},
                query: {
                    redirect: this.$utils.objArgs(
                        this.$router.currentRoute.path,
                        this.params
                    ),
                },
            })
        }
    }
}
</script>